import { FC, useMemo } from 'react'

import clsx from 'clsx'

import { Props } from './model.ts'
import s from './styles.module.scss'

export const Paper: FC<Props> = ({
  padding = [4],
  type = 'white',
  children,
  isLoading,
  radius = '20px',
  height = 'auto',
  border,
  backgroundColor,
  className,
  onClick,
}) => {
  const memoPadding = useMemo(
    () => padding?.map((padding) => `${padding}px`).join(' '),
    [padding],
  )

  return (
    <div
      style={{
        height,
        borderRadius: radius,
        padding: memoPadding,
        border: border,
        background: backgroundColor,
      }}
      className={clsx(s.container, s[type], isLoading && s.loading, className)}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
